var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8335 1.83398V4.58398",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1665 1.83398V4.58398",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 7.79232V12.4948C18.9342 11.844 17.8983 11.459 16.7708 11.459C15.6433 11.459 14.5892 11.8531 13.7642 12.5223C12.655 13.3931 11.9583 14.759 11.9583 16.2715C11.9583 17.1698 12.215 18.0315 12.655 18.7465C12.9942 19.3057 13.4342 19.7915 13.9567 20.1673H7.83333C4.625 20.1673 3.25 18.334 3.25 15.584V7.79232C3.25 5.04232 4.625 3.20898 7.83333 3.20898H15.1667C18.375 3.20898 19.75 5.04232 19.75 7.79232Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9165 10.084H12.4165",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9165 14.666H9.31817",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5835 16.2715C21.5835 17.1698 21.3268 18.0315 20.8868 18.7465C20.6302 19.1865 20.3093 19.5715 19.9335 19.8832C19.0902 20.6348 17.9902 21.084 16.771 21.084C15.7168 21.084 14.7452 20.7448 13.9568 20.1673C13.4343 19.7915 12.9943 19.3057 12.6552 18.7465C12.2152 18.0315 11.9585 17.1698 11.9585 16.2715C11.9585 14.759 12.6552 13.3931 13.7643 12.5223C14.5893 11.8531 15.6435 11.459 16.771 11.459C17.8985 11.459 18.9343 11.844 19.7502 12.4948C20.8685 13.3748 21.5835 14.7407 21.5835 16.2715Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7707 18.5618C16.7707 17.2968 17.7973 16.2702 19.0623 16.2702C17.7973 16.2702 16.7707 15.2435 16.7707 13.9785C16.7707 15.2435 15.744 16.2702 14.479 16.2702C15.744 16.2702 16.7707 17.2968 16.7707 18.5618Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.ace383054605a6d417da0f176dbc270e.svg";
export { ForwardRef as ReactComponent };